export default __webpack_public_path__ + "static/media/loginbanner.faf524a7.jpg";